<div class="mb-5">
  <div class="flex justify-content-between align-items-center flex-wrap mb-5 mt-5">
    <div class="flex justify-content-between align-items-center">
      <div class="text-800 text-2xl font-medium mr-4">{{ 'EIM_TITLE' | translate }}</div>
      <div class="border-round-2xl px-2 py-1" style="background-color: grey; color: white">{{ retestLabel }}</div>
    </div>
  </div>
  <div>{{ eimLabel }}<br><br></div>
  <div [innerHTML]="eimManagementOptions"></div>
</div>
